import {Chargement} from '@/components/Chargement/Chargement';
import {LOGO_FF_COULEUR_URL} from '@/domains/mediatheque/logoFFCouleurUrl';
import {Image, VStack} from '@chakra-ui/react';
import {useTranslation} from 'react-i18next';
import {imageOptimisee} from '../mediatheque/optimisation';

export const ChargementCompte: React.FC<{
  idMessage: string;
}> = ({idMessage}) => {
  const {t} = useTranslation();

  return (
    <VStack
      bg='white'
      minHeight='100vh'
      width='100%'
      justify='center'
      align='center'
      spacing={2}
    >
      <Image
        src={imageOptimisee(LOGO_FF_COULEUR_URL, 150)}
        alt={t('global.alt_logo_france_frais')}
        maxWidth='150px'
        mt={16}
      />
      <Chargement texte={t(`accueil.${idMessage}`)} />
    </VStack>
  );
};
